import { parse } from "url"

export const getHostnameFromUrl = (url: string) => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { parse } = require("url")

    return parse(url ?? "").hostname.replace("www.", "")
}
